// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/ethereum-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains the transaction data to estimate gas cost
 * @export
 * @interface EstimateGasBody
 */
export interface EstimateGasBody {
    /**
     * 
     * @type {string}
     * @memberof EstimateGasBody
     */
    data: string;
    /**
     * 
     * @type {string}
     * @memberof EstimateGasBody
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof EstimateGasBody
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof EstimateGasBody
     */
    value: string;
}

/**
 * Check if a given object implements the EstimateGasBody interface.
 */
export function instanceOfEstimateGasBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "from" in value;
    isInstance = isInstance && "to" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function EstimateGasBodyFromJSON(json: any): EstimateGasBody {
    return EstimateGasBodyFromJSONTyped(json, false);
}

export function EstimateGasBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateGasBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
        'from': json['from'],
        'to': json['to'],
        'value': json['value'],
    };
}

export function EstimateGasBodyToJSON(value?: EstimateGasBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'from': value.from,
        'to': value.to,
        'value': value.value,
    };
}

